import { z } from 'zod';
import { DeviceSlotSchema, TargetSchema } from './domain.js';
import { ExperimentDetailSchema } from './experiment.js';
import { ReviewResourceSchema } from './export.js';
import { ActivityJobSchema, JobStateSchema } from './activity.js';
export const STORE_DESIGNS_PATH = '/api/v1/store-designs';
export const STORE_DESIGN_RESOURCE = 'storeDesign';
export const STORE_DESIGN_EXPORT_RESOURCE = 'storeDesignExport';
export const CreateStoreDesignRequestSchema = z.object({
    appId: z.uuid(),
    title: z.string().trim().min(1).max(120),
    brief: z.string().trim().min(1).max(20_000),
    storeListingId: z.uuid().nullable().default(null),
    target: TargetSchema.optional(),
    deviceSlot: DeviceSlotSchema.default('phone'),
    materialIds: z.array(z.uuid()).max(50).default([]),
    sourceDesignId: z.uuid().nullable().default(null),
}).strict();
export const StoreDesignResourceSchema = z.object({
    id: z.uuid(),
    version: z.number().int(),
    title: z.string(),
    appId: z.uuid(),
    appName: z.string(),
    storeListingId: z.string().nullable(),
    storeListingName: z.string(),
    target: TargetSchema,
    deviceSlot: DeviceSlotSchema,
    iconExperimentId: z.uuid(),
    screenshotsExperimentId: z.uuid(),
    iconCandidateId: z.uuid().nullable(),
    screenshotsCandidateId: z.uuid().nullable(),
    sourceDesignId: z.uuid().nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const SelectStoreDesignCandidateRequestSchema = z.object({
    assetType: z.enum(['appIcon', 'screenshotSet']),
    candidateId: z.uuid().nullable(),
}).strict();
export const GenerateStoreDesignRequestSchema = z.object({
    kind: z.enum(['initial', 'explore']).default('initial'),
    assetType: z.enum(['appIcon', 'screenshotSet']).optional(),
}).strict();
export const StoreDesignGenerationResultSchema = z.object({
    results: z.array(z.object({
        assetType: z.enum(['appIcon', 'screenshotSet']),
        error: z.string().nullable(),
    })),
});
export const CreateStoreDesignExportRequestSchema = z.object({
    /** Distinguishes a fresh preparation after the preceding export failed or completed. */
    previousExportId: z.uuid().nullable().default(null),
}).strict();
export const StoreDesignGenerationSchema = z.object({
    mode: z.enum(['demo', 'provider', 'unavailable']),
    note: z.string(),
    iconProvider: z.string().nullable(),
    screenshotsProvider: z.string().nullable(),
});
export const StoreDesignExportResourceSchema = z.object({
    id: z.uuid(),
    jobId: z.uuid().nullable(),
    state: JobStateSchema,
    message: z.string().nullable(),
    fileName: z.string().nullable(),
    itemCount: z.number().int().nullable(),
    downloadPath: z.string().nullable(),
    iconCandidateId: z.uuid(),
    screenshotsCandidateId: z.uuid(),
    matchesSelection: z.boolean(),
    createdAt: z.string(),
});
export const StoreDesignDetailSchema = z.object({
    design: StoreDesignResourceSchema,
    icon: ExperimentDetailSchema,
    screenshots: ExperimentDetailSchema,
    iconReview: ReviewResourceSchema,
    screenshotsReview: ReviewResourceSchema,
    exports: z.array(StoreDesignExportResourceSchema),
    jobs: z.array(ActivityJobSchema.pick({ id: true, state: true, message: true })),
    progress: z.array(z.object({
        slotId: z.string().min(1),
        /** Only images already saved in BlobStore count as completed. */
        completed: z.number().int().nonnegative(),
        total: z.number().int().positive(),
        queuedAt: z.string().min(1),
        /** Saved frames available before the complete Candidate exists. */
        images: z.array(z.object({ position: z.number().int().nonnegative(), artifactId: z.string().min(1) })),
    })),
    generation: StoreDesignGenerationSchema,
});
export function storeDesignExportDownloadPath(exportId) {
    return `${STORE_DESIGNS_PATH}/exports/${exportId}/download`;
}
//# sourceMappingURL=store-design.js.map